<template>
  <div>
    <b-container class="bv-example-row">
      <b-row>
        <b-col cols="3">
          <sidebaroverview />
        </b-col>
        <b-col cols="9">
          <a-tabs defaultActiveKey="1" class="air-tabs-bordered mb-2">
            <a-tab-pane tab="Abouts" key="1">
              <abouts :profile="profile" />
            </a-tab-pane>
            <a-tab-pane tab="Settings" key="3">
              <settings :profile="profile" />
            </a-tab-pane>
          </a-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Sidebaroverview from "./sidebaroverview";
import Abouts from "./abouts";
import Settings from "./settings";
import { mapGetters } from "vuex";

export default {
  components: {
    Abouts,
    Settings,
    Sidebaroverview
  },
  created() {
    this.$nprogress.start();
    this.$store
      .dispatch("user/getProfile")
      .then(() => {
        this.$nprogress.done();
      })
      .catch(error => {
        this.$nprogress.done();
        this.$store.dispatch("user/showNotification", {
          title: error.code,
          description: error.message,
          variant: "danger"
        });
      });
  },
  methods: {
    handleEditNameClick() {
      this.isEditingName = !this.isEditingName;
    }
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    })
  },
  data() {
    return {
      isEditingName: false,
      fullName: ""
    };
  }
};
</script>
